import React from "react";
import { getCurrentSchemeAndHost } from "../../util/windowLocationUtil";
export default class OAuth extends React.Component {
    render() {
        const { from } = this.props.location.state || {
            from: { pathname: "/", search: "" },
        };
        let redirectUri = "/aviso/app/oauth/receiver";
        if (/\/app\/admin\//.test(from.pathname)) {
            redirectUri = "/aviso/app/admin/oauth/receiver";
        }
        window.location.href = `/aviso/oauth/authorize?response_type=token&scope=read%20write&client_id=avisoInternal&redirect_uri=${encodeURIComponent(`${getCurrentSchemeAndHost()}${redirectUri}`)}&state=${encodeURIComponent(encodeURIComponent(`${from.pathname}${from.search}`))}`;
        return null;
    }
}
